import { render, staticRenderFns } from "./BookingTemplateForm.vue?vue&type=template&id=7f77346b&"
import script from "./BookingTemplateForm.vue?vue&type=script&lang=js&"
export * from "./BookingTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VDivider,VLabel,VTextField})
